import { Map as ImmutableMap, Record } from 'immutable';
import * as ActionTypes from '../actions/ActionTypes';
import { isPublished } from '../utils/articleUtils';
import { getAllArticles, translate } from '../utils/categoryUtils';
import { getLanguageNameFromCode } from 'knowledge-content-ui/utils/langUtils';
export const HomepageCategoriesSettingsRecord = Record({
  articlesMap: ImmutableMap(),
  categoriesMap: ImmutableMap()
});
function isReady(slice) {
  return !slice.isRequesting && !slice.isUpdating && slice.lastLoaded !== null;
}
function getArticlesMap(state = {}) {
  const {
    categoryOrganizationInfo,
    homepageOrganization
  } = state;
  if (!isReady(categoryOrganizationInfo)) {
    return state.homepageCategoriesSettings.articlesMap;
  }
  const {
    categories
  } = categoryOrganizationInfo;
  const articleByIdOrParentId = (articleId, articles) => articles.get(articleId) || articles.find(article => article.values.hs_translated_from_id === articleId);
  return ImmutableMap(homepageOrganization.knowledgeCategories.filter(category => category.isDisplayed).map(({
    articles,
    knowledgeCategoryId
  }) => {
    const allCategoryArticles = getAllArticles(categories.get(knowledgeCategoryId));
    const parsedArticles = articles.filter(articleId => {
      return isPublished(articleByIdOrParentId(articleId, allCategoryArticles));
    }).map(articleId => articleByIdOrParentId(articleId, allCategoryArticles).values.hs_name).toArray();
    return [knowledgeCategoryId, parsedArticles];
  }).toArray());
}
function getCategoriesMap(state = {}) {
  const {
    categoryOrganizationInfo,
    homepageOrganization
  } = state;
  if (!isReady(categoryOrganizationInfo)) {
    return state.homepageCategoriesSettings.categoriesMap;
  }
  return ImmutableMap(homepageOrganization.knowledgeCategories.filter(category => {
    return !!(categoryOrganizationInfo.categories.get(category.knowledgeCategoryId) && category.isDisplayed);
  }).map(({
    color,
    knowledgeCategoryId
  }) => {
    const category = categoryOrganizationInfo.categories.get(knowledgeCategoryId);
    const {
      primaryLanguage,
      requestedLanguage
    } = categoryOrganizationInfo;
    const {
      name,
      description,
      language
    } = translate({
      category,
      primaryLanguage,
      requestedLanguage
    });
    return [knowledgeCategoryId, {
      color,
      name,
      description,
      languageTag: requestedLanguage && getLanguageNameFromCode(requestedLanguage),
      showRequestedLanguage: language && language !== categoryOrganizationInfo.requestedLanguage
    }];
  }).toArray());
}
export default function reducer(state = {
  homepageCategoriesSettings: new HomepageCategoriesSettingsRecord()
}, {
  type
}) {
  switch (type) {
    case ActionTypes.FETCH_TEMPLATE_SETTINGS_SUCCESS:
    case ActionTypes.UPDATE_TEMPLATE_SETTINGS_SUCCESS:
    case ActionTypes.FETCH_CATEGORIES_ORGANIZATION_SUCCESS:
    case ActionTypes.FETCH_TRANSLATED_CATEGORY_ORGANIZATION_SUCCESS:
    case ActionTypes.TEMPLATE_EDITOR_DELETE_ARTICLE_ON_HOME_PAGE:
    case ActionTypes.TEMPLATE_EDITOR_PUT_ARTICLE_ON_HOME_PAGE:
    case ActionTypes.TEMPLATE_EDITOR_DROP_ARTICLE_ON_HOME_PAGE:
    case ActionTypes.UPDATE_CATEGORY_SUCCESS:
    case ActionTypes.UPDATE_CATEGORY_TRANSLATIONS_SUCCESS:
    case ActionTypes.TEMPLATE_EDITOR_UPDATE_CATEGORY_COLOR:
      return Object.assign({}, state, {
        homepageCategoriesSettings: new HomepageCategoriesSettingsRecord({
          articlesMap: getArticlesMap(state),
          categoriesMap: getCategoriesMap(state)
        })
      });
    default:
      {
        const {
          homepageCategoriesSettings = new HomepageCategoriesSettingsRecord()
        } = state;
        return Object.assign({}, state, {
          homepageCategoriesSettings
        });
      }
  }
}